import React, { PropsWithChildren, useState, useEffect } from 'react';
import {
    MappedComponentProperties,
} from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { useAcquisitionContext } from '../../providers/AcquisitionProvider/AcquisitionProvider';

import './ConsumerReport.css';
import { getAppData } from '../../utils/acquisition-utils';
import { InputCheckbox } from 'component-library/index';
import { Row, Col, Container } from '../../importCL';
import withAsyncImport from '../../withAsyncImport';
const ConsumerReportPrintModal = withAsyncImport(() => import('./ConsumerReportPrintModal/ConsumerReportPrintModal'));

interface IConsumerReportProps extends MappedComponentProperties {
    bottomBorderAdded?: boolean;
    topBorderAdded?: boolean;
    title?: string;
    descriptionText?: string;
    bottomDescriptionText?: string;
    checkboxAgreeText?: string;
    modalTitle?: string;
}

export const ConsumerReportEditConfig = {
    emptyLabel: 'Consumer Report',
    isEmpty: (props: PropsWithChildren<IConsumerReportProps>) => {
        return !props || !props.title;
    },
};

const ConsumerReport = (
    props: PropsWithChildren<IConsumerReportProps>,
): JSX.Element => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const { 
        isConsumerReportAgreed,
        setIsConsumerReportAgreed,
    } = useAcquisitionContext();

    const getDescriptionText = () => {
        if (props.descriptionText) {
            return (
                <Col className='ConsumerReport__descriptionText mt-2 mb-4'>
                    {transformHTMLParserLinks(props.descriptionText)}
                    {!isModalOpen && (
                        <>
                            {' '}
                            <a className='ConsumerReport__openModal' onClick={() => setIsModalOpen(!isModalOpen)}>
                                Print this authorization
                            </a>
                            <span className='ConsumerReport__printText'>
                                {' '}
                                for your records.{' '}
                            </span>{' '}
                        </>
                    )}
                    {props.bottomDescriptionText && (
                        <div className='ConsumerReport__bottomDescriptionText'>
                            {transformHTMLParserLinks(props.bottomDescriptionText)}
                        </div>
                    )}
                </Col>
            );
        }
    };

    useEffect(() => {
        getAppData().then(appData => {
            // always false for PHA since there is no corresponding flag in new api.
            setIsConsumerReportAgreed(!!appData?.ConsumerAcknowledgment);
        });
    }, []);

    return (
        <Container id='consumer-report' className='ConsumerReport'>
            {props.topBorderAdded && (
                <hr className='ConsumerReport__hr' />
            )}
            <Row className='px-4'>
                <Col className='ConsumerReport__titleContainer' xs={12}>
                    {props.title && (
                        <h3 className='ConsumerReport__title'>
                            {transformHTMLParserLinks(props.title)}
                        </h3>
                    )}
                </Col>
                <>{getDescriptionText()}</>

                {props.checkboxAgreeText && (
                    <Col
                        className='ConsumerReport__agreeText no-print'
                        xs={12}
                    >
                        <form name='agreeConsumerReport'>
                            <InputCheckbox
                                id='agreeConsumerReportId'
                                name='agreeConsumerReport'
                                label={transformHTMLParserLinks(props.checkboxAgreeText)}
                                value={isConsumerReportAgreed}
                                setValue={setIsConsumerReportAgreed}
                                labelClass='ConsumerReport__agreeLabel'
                                checkboxId='consumer-auth-alt-checkbox'
                            />
                        </form>
                    </Col>
                )}

            </Row>
            {props.bottomBorderAdded && (
                <hr className='ConsumerReport__hr' />
            )}
            <ConsumerReportPrintModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                descriptionText={props.descriptionText}
                title={props.modalTitle || ''}
            />
        </Container>
    );
};

export default ConsumerReport;
